module.exports = __webpack_public_path__ + "img/ertiga-boostergreen-glx-blanco-perlado.a7151010.png";